type PropTypes = {
  className?: string
}

const BackIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="16"
        height="16"
        transform="translate(16) rotate(90)"
        fill="white"
        fillOpacity={0.01}
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M5.0002 8L10.0002 3L10.7002 3.7L6.40019 8L10.7002 12.3L10.0002 13L5.0002 8Z"
        fill="#161616"
      />
    </svg>
  )
}

export default BackIcon
